import { useDispatch, useSelector } from 'react-redux';

import * as profileActions from '../actions';
import * as profileSelectors from '../selectors';

export default function useLoadProfile() {
  const dispatch = useDispatch();
  const loading = useSelector(profileSelectors.getIsLoading);
  const profile = useSelector(profileSelectors.getProfile);
  const onLoadProfile = () => dispatch(profileActions.load());

  return { profile, loading, onLoadProfile };
}
